// TODO Define rxjs as a standalone dependency, remove rx from package.
// eslint-disable-next-line import/no-extraneous-dependencies
import { Observable, using } from 'rxjs';
import SocketBrokerObservableWrapper from '@Services/ResultsDataManage/SocketBrokerObservableWrapper';
import { RxSocketUrls } from '@Constants/CommonConstants';
import * as Results from '@Services/Results';
import * as FormatUtils from '@Services/FormatUtils';

const _getImagePath = (obj) => {
  return (
    obj && {
      ...obj,
      ...(obj.image && {
        image: {
          ...obj.image,
          url: FormatUtils.formatPath(obj.image.url),
        },
      }),
    }
  );
};

export const getSimilar = (id, databaseId, structure, channel, dbs) => {
  const observable = using(
    () => new SocketBrokerObservableWrapper(),
    (socketBrokerObservableWrapper) => {
      return new Observable((subscriber) => {
        socketBrokerObservableWrapper.observe(RxSocketUrls.ChannelsUrls.SearchInfo, (data) => {
          Logger.info('WS results similarity response:', data);
          if (data && data.payload) {
            subscriber.next({ payload: _getImagePath(data.payload) });
          }
        });
        subscriber.next({ payload: [] });
        Results.getSimilar(id, databaseId, structure, channel, dbs);
      });
    }
  );

  return observable;
};

export const getContextInfo = (context, id, databaseId, searchId, channel) => {
  const observable = using(
    () => new SocketBrokerObservableWrapper(),
    (socketBrokerObservableWrapper) => {
      return new Observable((subscriber) => {
        socketBrokerObservableWrapper.observe(RxSocketUrls.ChannelsUrls.SearchInfo, (data) => {
          Logger.info('WS results context info response:', data);
          if (data && data.payload) {
            subscriber.next(data);
          }
        });
        Results.getContextInfo(context, id, databaseId, searchId, channel);
      });
    }
  );

  return observable;
};
